import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome' 
import {faTimes} from '@fortawesome/free-solid-svg-icons'
import InformePedidosPdf from './informePedidosPdf'

const CrearInforme = ({setFuncion, logo, data2, resultados}) => {
	
  return (
    <div>
        <div className="container row">
						<div className="col-md-12">
							<h3>Crear Informe: </h3>
						</div>
							<div className="col-md-12">
								<button 
									onClick={e => setFuncion('ver')}
									className="btn boton_estandar_blanco float-right">
									<FontAwesomeIcon icon={faTimes} size="lg"/>
								</button> 
								{/* <CSVLink  
									className="btn boton_estandar_blanco float-right" {...csvReport}>
									<FontAwesomeIcon icon={faCloudDownloadAlt} size="lg"/> CSV
								</CSVLink> */}
								<InformePedidosPdf 
									logo={logo}
									data={data2}	
									resultados={resultados}			
								/>
							</div>
					</div>
    </div>
  )
}

export default CrearInforme